import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiPlus } from 'react-icons/fi';

const FAQItem = ({ q, a }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-line">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full py-8 flex justify-between items-center text-left group"
      >
        <span className="font-fraunces text-xl md:text-2xl text-navy group-hover:text-brass transition-colors pr-8">
          {q}
        </span>
        <motion.div
          animate={{ rotate: isOpen ? 45 : 0 }}
          className="text-brass shrink-0"
        >
          <FiPlus size={24} />
        </motion.div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden"
          >
            <p className="pb-8 text-navy/70 leading-relaxed max-w-3xl">
              {a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  const faqs = [
    {
      q: "How much does a mobile notary appointment cost?",
      a: "Most appointments fall between $30 and $75 all-in, depending on the document type, number of signatures, and where you are. We give you a flat quote up front, no surprise fees at the door. Just call or text us with what you need and we'll send a quote."
    },
    {
      q: "Do I need to come to you, or do you come to me?",
      a: "We come to you. That's the whole point of mobile notary. Your home, your office, a hospital, a coffee shop, a nursing home, wherever you need us. If we can drive there safely, we'll be there."
    },
    {
      q: "What do I need to bring to a notary appointment?",
      a: "Two things: a valid government-issued photo ID (driver's license, passport, or state ID), and the document you need notarized. Do not sign the document before the appointment, we have to watch you sign it. If anyone else needs to sign too, they need to be there with their own ID."
    },
    {
      q: "Can you help me with documents going to Brazil?",
      a: "Yes. Brazil is part of the Hague Convention, which means documents need an apostille to be recognized there. We handle the full apostille process: we notarize the document, take it to the PG County Circuit Court in Upper Marlboro for clerk certification, then to the Maryland Secretary of State in Annapolis for the apostille. Available in Portuguese."
    },
    {
      q: "Are you available on evenings and weekends?",
      a: "Yes, those are actually our specialty. Weekday evenings 5pm to 10pm, weekends 8am to 9pm. We know banks close at 4pm and most notaries don't work weekends. We do."
    },
    {
      q: "Do you offer I-9 verification for remote employees?",
      a: "Yes. If your company has hired someone in the Laurel, PG County, or Montgomery County area, Carlos can meet them in person to complete the I-9 process on your behalf as your authorized representative. Contact us to schedule."
    },
    {
      q: "Can you give me legal advice about my document?",
      a: "No. Notaries aren't attorneys, and Maryland law requires us to be upfront about that. We can verify your identity and witness your signature. Anything about what your document means or whether it's the right document needs to go to a licensed attorney."
    },
    {
      q: "Do you handle loan signings or refinances?",
      a: "Not yet. Loan signings require a separate certification, which we're working toward. For now, we handle every other type of notarization, just not full real estate or title closings."
    }
  ];

  return (
    <section id="faq" className="py-24 px-6 bg-cream-light">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-brass text-xs font-bold tracking-[0.2em] uppercase mb-4 block">COMMON QUESTIONS</span>
          <h2 className="font-fraunces text-4xl md:text-5xl text-navy mb-6">
            Things people <span className="italic text-brass">usually want to know.</span>
          </h2>
          <p className="text-lg text-navy/70">
            A few quick answers. If yours isn't here, just call or text.
          </p>
        </div>

        <div className="border-t border-line">
          {faqs.map((faq, i) => (
            <FAQItem key={i} q={faq.q} a={faq.a} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;